<template>
  <v-layout mt-3 row wrap>
    <v-flex xs12>
      <v-checkbox v-for="action in availableActions"
                  :key="action"
                  class="my-0 py-0"
                  @change="onChange"
                  :label="$t(`message.permissions.actions.${action}`)"
                  :input-value="value"
                  :value="action"></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'nx-authorization-permissions-wizard-actions',
  props: {
    value: {
      type: Array,
      required: true,
    },
    availableActions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>
